<template>
    <div id="app">
        <div class="hero6">
            <div class="section">
                <div class="columns-4 w-row">
                    <div class="column-8 w-col w-col-6 w-col-stack">
                        <div class="hero6-content">
                            <div class="hero6-text">
                                <div class="div-block-17">
                                    <h6 class="heading">#IndustryResponse</h6>
                                    <div class="div-block-4"></div>
                                </div>
                                <div class="sizejumbo-text sizejumbo-full-clear">Calling all suppliers – </div>
                                <div class="sizejumbo-text sizejumbo-full-clear"><strong>Help Canada combat Coronavirus disease (COVID-19)</strong></div>
                                <p class="paragraph-71 pushdown">In support of the Government of Canada’s <a href="https://pm.gc.ca/en/news/news-releases/2020/03/11/prime-minister-outlines-canadas-covid-19-response" class="link-2">whole-of-government response to Coronavirus disease (COVID-19)</a>, we are asking suppliers and manufacturers about their ability to provide products.</p>
                                <p class="paragraph-71">Questions? Contact <a href="mailto:contact@rrpcanada.com" class="link">contact@rrpcanada.com</a></p>
                            </div>
                            <div class="div-block-22 hidemobile top-padding"></div>
                        </div>
                    </div>
                    <div class="column-4 column-2 mobilepush w-col w-col-6 w-col-stack">
                        <div class="div-block-16 mobileformat">
                            <div class="text-block-7 mobilehide">Critical Products</div>
                            <div class="shortages-table mobilehide">
                              <CriticalProducts/>
                            </div>
                            <a class="button-alert w-button" href="#"
                               v-scroll-to="{el: '#Products'}">Offer Support</a>
                            <a class="offer-shortage-materials cta w-button" href="#"
                               v-scroll-to="{el: '#Products'}">Request Critical Supplies</a>
                        </div>
                        <div class="div-block-5 mobileformat"></div>
                    </div>
                </div>
            </div>
        </div>
        <Products/>
        <AvailableInputMaterials/>
        <CriticalInputMaterials/>
        <div id="Critical-Shortages" class="wrapper m0-50 critical">
            <div class="section">
                <div class="sponsor-zone">
                    <div class="sponsor-type">Anchor Sponsors</div>
                    <div class="light-hr"></div>
                    <div class="anchor-sponsor-container">
                        <img src="https://uploads-ssl.webflow.com/5e862a043df4d14c930ef3dd/5e999c6785ef986b48770440_BASF.png" width="201" sizes="(max-width: 479px) 92vw, 250px" alt="" class="anchor-sponsor">
                    </div>
                    <div class="sponsor-type">Supporting Sponsors</div>
                    <div class="light-hr"></div>
                    <div class="supporting-sponsors-container">
                        <img src="https://uploads-ssl.webflow.com/5e862a043df4d14c930ef3dd/5e9f8699578be557d009e4f6_trimac.png" width="131" alt="" class="supporting-sponsor">
                    </div>
                    <router-link v-bind:to="'/contribute'"  class="button-alert w-button">How to Contribute</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Products from "./Products";
    import CriticalProducts from './CriticalProducts.vue';
    import AvailableInputMaterials from "./AvailableInputMaterials";
    import CriticalInputMaterials from "./CriticalInputMaterials";

    export default {
        name: "MainPage",
        components: {
            CriticalInputMaterials,
            Products,
            CriticalProducts,
            AvailableInputMaterials
        },
        data () {
            return {
                accessToken: {}
            }
        },
        created () {
            document.title = "Rapid Response Platform";
            this.accessToken = JSON.parse(localStorage.getItem('accessToken'));
        }
    }

</script>

<style scoped>

</style>
